import { Flexi } from "slotworks/graphics/elements/abstract-flexi";
import ButtonElement from "slotworks/graphics/elements/button-element";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";

export default class FlexiButton extends Flexi<PIXI.Sprite | ButtonElement | HTMLElement> {

    private name: string;

    public addTarget(target: PIXI.Sprite | ButtonElement | HTMLElement) {
        super.addTarget(target);

        if (target instanceof HTMLElement) {
            this.name = target.id;
            target.addEventListener(ButtonEvent.POINTER_DOWN.getEventString(), this.onDown);
            target.addEventListener(ButtonEvent.POINTER_UP.getEventString(), this.onUp);
        }
    }

    public destroy() {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                this.name = target.id;
                target.removeEventListener(ButtonEvent.POINTER_DOWN.getEventString(), this.onDown);
                target.removeEventListener(ButtonEvent.POINTER_UP.getEventString(), this.onUp);
            }
        }
    }

    public on(event: ButtonEvent, handler: Function) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.addEventListener(event.getEventString(), handler as any);
            } else if (target instanceof ButtonElement) {
                target.on(event, handler);
            } else {
                target.on(event.getEventString(), handler);
            }
        }
    }

    public off(event: ButtonEvent, handler: Function) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.removeEventListener(event.getEventString(), handler as any);
            } else if (target instanceof ButtonElement) {
                target.off(event, handler);
            } else {
                target.off(event.getEventString(), handler);
            }
        }
    }

    public setSelected(selected: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle("selected", selected);
            } else if (target instanceof ButtonElement) {
                target.setSelected(selected);
            } else {
                throw new Error("Not implemented");
            }
        }
    }

    public setVisible(visible: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle(visible ? "hidden" : "visible", false);
                target.classList.toggle(visible ? "visible" : "hidden", true);
            } else if (target instanceof ButtonElement) {
                target.setVisible(visible);
            } else {
                target.visible = visible;
            }
        }
    }

    public setEnabled(enabled: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle(enabled ? "disabled" : "enabled", false);
                target.classList.toggle(enabled ? "enabled" : "disabled", true);
            } else if (target instanceof ButtonElement) {
                target.setEnabled(enabled);
            } else {
                target.buttonMode = enabled;
            }
        }
    }

    private onDown = () => {
        SoundManager.event(SoundEvent.button_press_NAME, this.name);

        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle("down", true);
            }
        }
    }

    private onUp = () => {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle("down", false);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/elements/flexi-button.ts